import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgChatten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M19 6c7.732 0 14 6.268 14 14 0 2.989-.936 5.758-2.532 8.032L32 33l-4.968-1.532A13.94 13.94 0 0 1 19 34c-7.732 0-14-6.268-14-14S11.268 6 19 6"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M19 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M25 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M13 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#00215B"
      d="M25 9.308A12.8 12.8 0 0 0 15.887 5.5C8.77 5.5 3 11.32 3 18.5s5.77 13 12.887 13v-1C9.324 30.5 4 25.13 4 18.5s5.324-12 11.887-12c3.195 0 6.187 1.277 8.403 3.512z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgChatten);

export default ForwardRef;
